import { render, staticRenderFns } from "./VCA_Other.vue?vue&type=template&id=35afb31c&scoped=true&"
import script from "./VCA_Other.vue?vue&type=script&lang=ts&"
export * from "./VCA_Other.vue?vue&type=script&lang=ts&"
import style0 from "./VCA_Other.vue?vue&type=style&index=0&id=35afb31c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35afb31c",
  null
  
)

export default component.exports